<template lang="pug">
  tbody
    tr
      th(colspan=2) {{ lotto_title }}
      td.text-center {{ lotto_upline_pt }}%
      td.text-center(v-show="isSearch") {{ lotto_account_pt }}%
      td.text-center(v-show="isSearch") {{ lotto_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ lotto_account_min }}%
</template>

<script>
export default {
  props: {
    isSearch: false
  },
  data() {
    return {
      lotto_upline_min: 0,
      lotto_upline_max: 0,
      lotto_upline_pt: 0,
      lotto_account_pt: 0,
      lotto_upline_remaining: 0,
      lotto_account_min: 0
    }
  },
  computed: {
    lotto_title: function () {
      return this.$t("ui.lotto") + " (" + this.lotto_upline_min + "%-" + this.lotto_upline_max + "%)"
    }
  }
}

</script>